var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KModal",
    {
      attrs: {
        title: _vm.header,
        cancelText: _vm.cancelText,
        submitText: _vm.submitText,
        submitDisabled: _vm.submitDisabled,
      },
      on: {
        submit: _vm.handleSubmit,
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _vm.canRemove
        ? [
            _c("p", { style: { color: _vm.$themeTokens.error } }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$tr("willLoseAccessWarning", {
                      facilityName: _vm.facilityName,
                    })
                  ) +
                  "\n    "
              ),
            ]),
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$tr("facilityReloadExplanation")) +
                  "\n    "
              ),
            ]),
            _c("KCheckbox", {
              attrs: {
                checked: _vm.confirmationChecked,
                label: _vm.$tr("removingFacilityConfirmation"),
              },
              on: {
                change: function ($event) {
                  _vm.confirmationChecked = $event
                },
              },
            }),
          ]
        : [
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$tr("cannotRemoveOwnFacilityExplanation")) +
                  "\n    "
              ),
            ]),
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$tr("signInAsOtherAdminExplanation", {
                      facilityName: _vm.facilityName,
                    })
                  ) +
                  "\n    "
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }